import * as React from 'react';
import { OrderedMap } from 'immutable';

import DateFilter from 'views/components/widgets/overview-configuration/filters/DateFilter';
import type { FilterComponents } from 'views/components/widgets/overview-configuration/filters/types';
import StatusFilter from 'search/events/filters/StatusFilter';
import Status from 'search/events/Status';
import OwnerFilter from 'security-app/components/SecurityEvents/Alerts/OwnerFilter';
import { OwnerCell } from 'security-app/components/SecurityEvents/Alerts/ColumnRenderers';

const dateFilterComponents = {
  configuration: (
    _selectedValues,
    editValue: Array<string>,
    onChange: (newValue: Array<string>, shouldSubmit: boolean) => void,
  ) => <DateFilter values={editValue} onChange={(newValue) => onChange(newValue, false)} />,
  renderValue: (values: string) => values.replace(',', ' to '),
  valueForConfig: (values: Array<string>) => values.join(','),
  valueFromConfig: (value: string) => (value ? value.split(',') : []),
  submitChangesOnClose: true,
};

const filterComponents: FilterComponents = [
  {
    attribute: 'opened_at',
    ...dateFilterComponents,
  },
  {
    attribute: 'updated_at',
    ...dateFilterComponents,
  },
  {
    attribute: 'closed_at',
    ...dateFilterComponents,
  },
  {
    configuration: (selectedValues, editValue: string, onChange: (newValue: string) => void) => (
      <OwnerFilter
        attribute={{ id: 'owner', title: 'Owner' }}
        allActiveFilters={OrderedMap(
          selectedValues.length > 0
            ? {
                owner: selectedValues.map((value) => ({ value, title: value })),
              }
            : {},
        )}
        filter={editValue ? { value: editValue, title: editValue } : undefined}
        filterValueRenderer={(value) => <OwnerCell owner={value} highlightCurrentUser />}
        onSubmit={({ value }) => onChange(value)}
      />
    ),
    attribute: 'owner',
    renderValue: (value) => <OwnerCell owner={value} highlightCurrentUser />,
    allowMultipleValues: true,
  },
  {
    configuration: (selectedValues, editValue: string, onChange: (newValue: string) => void) => (
      <StatusFilter value={editValue} onSelect={onChange} selectedValues={selectedValues} />
    ),
    attribute: 'status',
    renderValue: (value) => <Status statusId={value} />,
    allowMultipleValues: true,
  },
];

export default filterComponents;
